import { connect } from 'react-redux';

import { getMappingCode, getMyPermissions } from '../../../reducers/analyticsApp';
import { startUpdateMappingCode } from '../../../actions/mapping';
import MappingPresentationPane from '../../../components/mapping/manual/PresentationPane';
import { staticPermissions } from '../../../constants/authorization';

const mapStateToProps = (state) => ({
  code: getMappingCode(state),
  hasPermission: getMyPermissions(state).has(staticPermissions.METAINF_MANAGE),
});

const mapDispatchToProps = {
  onEdit: startUpdateMappingCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(MappingPresentationPane);
